import type { AssignedResourcesTranslationMessages } from './assignedResourcesTranslationMessages';

export const assignedResourcesLanguageEnglish: AssignedResourcesTranslationMessages = {
  assigned_lcrs: {
    name: 'Least Cost Routing',
    fields: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_sip_profiles: {
    name: 'SIP Profiles',
    fields: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_carriers: {
    name: 'SIP Trunks',
    fields: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
      labels: 'Labels',
    },
  },
  assigned_inbound_e164s: {
    name: 'Inbound E164',
    fields: {
      id: 'ID',
      e164_match: 'E164 Match',
      description: 'Description',
      labels: 'Labels',
      callflow: 'Dialplan',
    },
  },
};
